import React from 'react';
import SortIcon from 'components/molecules/common/Icon/SortIcon';

interface IProps {
    headerColumns: TableHeader[];
}
export interface TableHeader {
    key: string;
    label: string;
    allowSort: boolean;
}

const OptimizePlanTableHeader: React.FC<IProps> = ({ headerColumns }) => {
    return (
        <div className="flex gap-4 p-4 bg-greyBackgroundAlt">
            {headerColumns.map((item: TableHeader) => (
                <div key={item.key} className={`flex items-center justify-between flex-1`}>
                    <div className={`${item.key === 'val' ? 'm-auto' : ''}`}>{item.label}</div>
                    {item.allowSort && <SortIcon onClick={() => {}} />}
                </div>
            ))}
        </div>
    );
};

export default React.memo(OptimizePlanTableHeader);
